import type { ActorRefFrom } from 'xstate';
import { UserContextV2 } from '~/app';
import { LoadingSpinner } from '~/components';
import { PROVIDER_REGISTRATION_VIEW } from '~/features/xstateSystem';
import { Registration } from './Registration';
import { providerRegistrationView } from './registration-view.machine';

/**
 * Provider Registration Route Component
 *
 * Connects userState providerRegistration view machine to Registration UI
 * The view machine is invoked by userState with a systemId for stable access
 */
export const ProviderRegistrationRoute = () => {
  const providerRegistrationRef = UserContextV2.useSelector(
    (state) =>
      state.children?.[PROVIDER_REGISTRATION_VIEW] as
        | ActorRefFrom<typeof providerRegistrationView>
        | undefined
  );

  if (!providerRegistrationRef) {
    return (
      <div className="min-h-screen bg-base flex items-center justify-center">
        <div className="text-center">
          <LoadingSpinner />
          <p className="text-grey-300">Starting registration...</p>
        </div>
      </div>
    );
  }

  return <Registration actorRef={providerRegistrationRef} />;
};
